import { render, staticRenderFns } from "./HeaderUserMenu.vue?vue&type=template&id=5979eb5e&scoped=true&"
import script from "./HeaderUserMenu.vue?vue&type=script&lang=js&"
export * from "./HeaderUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./HeaderUserMenu.vue?vue&type=style&index=0&id=5979eb5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5979eb5e",
  null
  
)

export default component.exports